
import _ from 'lodash';

class LocationSorter {

    /**
     *
     * @param lines {array}
     * @returns {*}
     */
    sortByLocationCodes(lines) {
        return _.sortBy(lines, line => {
            if (line.location.id < 2) {
                return ['ZZZZZZZZZZZZZZZ'];
            }
            let zone = line.location.code.slice(0,4);
            if (line.location?.zone?.code) {
                zone = `000${line.location?.zone?.code.slice(-4)}`;
            }
            const aisle = `000${parseInt(line.location.aisle)}`.slice(-4);
            const shelf = `000${line.location.shelf}`.slice(-4);
            const pallet = `000${line.location.pallet}`.slice(-4);
            let code = `${zone}-${aisle}`;
            if (line.location.shelf) {
                code += `-${shelf}`;
            }
            if (line.location.pallet) {
                code += `-${pallet}`;
            }
            console.log(`Using ${code}`, {...line.location});
            return code;
        });
    }
}
export default new LocationSorter;
